import { create } from 'zustand';

/**
 * Store global para o fluxo de agendamento
 * Gerencia o estado das etapas, serviços selecionados e dados do agendamento
 */
export const useBookingStore = create((set, get) => ({
  // Estado inicial
  step: 1,
  services: [],
  date: null,
  time: null,
  professional: null,
  client: {
    name: '',
    phone: '',
    email: '',
    notes: ''
  },

  // Navegação entre etapas
  nextStep: () => set((state) => ({ step: state.step + 1 })),
  prevStep: () => set((state) => ({ step: state.step - 1 })),
  setStep: (step) => set({ step }),

  // Gerenciamento de serviços
  addService: (service) => set((state) => ({ 
    services: [...state.services, service] 
  })),
  removeService: (serviceId) => set((state) => ({ 
    services: state.services.filter(s => 
      (typeof s === 'object' ? s.id !== serviceId : s !== serviceId)
    ) 
  })),
  setServices: (services) => set({ services }),
  
  // Data e hora
  setDate: (date) => set({ date }),
  setTime: (time) => set({ time }),
  
  // Profissional
  setProfessional: (professional) => set({ professional }),
  
  // Dados do cliente
  setClientField: (field, value) => set((state) => ({
    client: { ...state.client, [field]: value }
  })),
  setClient: (client) => set({ client }),
  
  // Utilitários
  resetBooking: () => set({
    step: 1,
    services: [],
    date: null,
    time: null,
    professional: null,
    client: {
      name: '',
      phone: '',
      email: '',
      notes: ''
    }
  }),
  
  // Calculadoras e getters
  getTotalDuration: () => {
    const { services } = get();
    return services.reduce((total, service) => 
      total + (typeof service === 'object' ? service.duracao : 0), 0);
  },
  
  getTotalPrice: () => {
    const { services, professional } = get();
    
    return services.reduce((total, service) => {
      if (typeof service !== 'object') return total;
      
      // Verificar se existe preço personalizado para o profissional
      if (professional && professional.id && 
          service.professionalCustomizations && 
          service.professionalCustomizations[professional.id] &&
          service.professionalCustomizations[professional.id].customPrice !== null) {
        return total + service.professionalCustomizations[professional.id].customPrice;
      }
      
      return total + service.preco;
    }, 0);
  }
})); 